import React from 'react';
import DocumentationSidebar from './component/DocumentationSidebar';
import { DocContentImage, DocModalImage, DocSidebarImage } from './component/DocMedia';
import { useTranslation } from 'react-i18next';
import { useDocImage } from './hooks/useDocImage';

export default function Tickets() {
  const { t } = useTranslation();
  const image001 = useDocImage('tickets-img', 'image001.png');
  const image002 = useDocImage('tickets-img', 'image002.png');
  const image003 = useDocImage('tickets-img', 'image003.png');
  const image004 = useDocImage('tickets-img', 'image004.png');
  const image005 = useDocImage('tickets-img', 'image005.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.tickets.title')}</h1>
            <p className="header-para">{t('documentation.tickets.intro')}</p>
            <DocContentImage src={image002} alt={t('documentation.tickets.listOverview.imageAlt')} className="pb-30" />

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.accessing.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.tickets.accessing.steps.step1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.tickets.accessing.steps.step2') }} />
                </ul>
                <DocSidebarImage src={image001} alt={t('documentation.tickets.accessing.imageAlt')} />
                <ul className="mb-0">
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.tickets.accessing.steps.step3') }} />
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.listOverview.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.tickets.listOverview.intro')}</p>
                <p className="mt-3"><b>{t('documentation.tickets.listOverview.dashboardTitle')}</b></p>
                <ul>
                  <li>{t('documentation.tickets.listOverview.dashboardItems.open')}</li>
                  <li>{t('documentation.tickets.listOverview.dashboardItems.acknowledged')}</li>
                  <li>{t('documentation.tickets.listOverview.dashboardItems.inProgress')}</li>
                  <li>{t('documentation.tickets.listOverview.dashboardItems.resolved')}</li>
                  <li>{t('documentation.tickets.listOverview.dashboardItems.total')}</li>
                </ul>
                <p className="mt-3"><b>{t('documentation.tickets.listOverview.filtersTitle')}</b></p>
                <ul>
                  <li>{t('documentation.tickets.listOverview.filtersItems.search')}</li>
                  <li>{t('documentation.tickets.listOverview.filtersItems.status')}</li>
                  <li>{t('documentation.tickets.listOverview.filtersItems.severity')}</li>
                  <li>{t('documentation.tickets.listOverview.filtersItems.source')}</li>
                  <li>{t('documentation.tickets.listOverview.filtersItems.assignee')}</li>
                </ul>
                <p className="mt-3"><b>{t('documentation.tickets.listOverview.tableTitle')}</b></p>
                <ul>
                  <li>{t('documentation.tickets.listOverview.tableItems.title')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.type')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.severity')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.status')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.source')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.assignedTo')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.created')}</li>
                  <li>{t('documentation.tickets.listOverview.tableItems.action')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.createTicket.title')}
              </div>
              <div className="card-body">
                <DocModalImage src={image003} alt={t('documentation.tickets.createTicket.imageAlt')} />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.tickets.createTicket.items.step1') }} />
                  <li>{t('documentation.tickets.createTicket.items.step2')}</li>
                  <li>{t('documentation.tickets.createTicket.items.step3')}</li>
                  <li>{t('documentation.tickets.createTicket.items.step4')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.ticketDetail.title')}
              </div>
              <div className="card-body">
                <DocContentImage src={image004} alt={t('documentation.tickets.ticketDetail.imageAlt')} />
                <ul>
                  <li>{t('documentation.tickets.ticketDetail.items.overview')}</li>
                  <li>{t('documentation.tickets.ticketDetail.items.comments')}</li>
                  <li>{t('documentation.tickets.ticketDetail.items.status')}</li>
                  <li>{t('documentation.tickets.ticketDetail.items.assign')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.alertTypes.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li>{t('documentation.tickets.alertTypes.items.bruteForce')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.unauthorizedToken')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.unknownUser')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.inactiveUser')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.suspiciousIp')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.afterHours')}</li>
                  <li>{t('documentation.tickets.alertTypes.items.manual')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.tickets.notifications.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.tickets.notifications.intro')}</p>
                <DocContentImage src={image005} alt={t('documentation.tickets.notifications.imageAlt')} />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.tickets.notifications.items.step1') }} />
                  <li>{t('documentation.tickets.notifications.items.step2')}</li>
                  <li>{t('documentation.tickets.notifications.items.step3')}</li>
                </ul>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.tickets.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
